export function hexToRgbA(hex: string, opacity: number) {
    let result: any;
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        result = hex.substring(1).split('');
        if (result.length == 3) {
            result = [result[0], result[0], result[1], result[1], result[2], result[2]];
        }
        result = '0x' + result.join('');
        return 'rgba(' + [(result >> 16) & 255, (result >> 8) & 255, result & 255].join(',') + ',' + opacity + ')';
    }
    throw new Error('Bad Hex');
}
